import { Language, useTranslation } from "./Localization";

const languages: Language[] = ["ro", "hu", "en", "de"];

export default function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { language, setLanguage, t } = useTranslation();
  return <div className={`language-switcher ${className}`.trim()} aria-label={t("accessibility.language")}>
    {languages.map((item) => <button type="button" key={item} className={language === item ? "active" : ""} onClick={() => setLanguage(item)} aria-pressed={language === item}><span>{item.toUpperCase()}</span></button>)}
  </div>;
}
